import {
  UpdateProcedureFilter,
  UpdateRecordFilter,
  UpdateTaskFilter,
  UpdateDocumentFilter,
  UpdateAccessRequestFilter,
  UpdateBreachFilter,
  UpdateCompanyFilter,
} from './mutationTypes'

const mutations = {
  /**
   * Update state by filter type
   *
   * @param {array}
   */
  [UpdateProcedureFilter](state, { value, type }) {
    if (state.procedure[type] !== undefined) {
      state.procedure[type] = value
    }
  },
  [UpdateRecordFilter](state, { value, type }) {
    if (state.record[type] !== undefined) {
      state.record[type] = value
    }
  },
  [UpdateTaskFilter](state, values) {
    state.task = values
  },
  [UpdateDocumentFilter](state, { key, value }) {
    state.documents[key] = value
  },
  [UpdateAccessRequestFilter](state, { key, value }) {
    state.accessRequest[key] = value
  },
  [UpdateBreachFilter](state, { key, value }) {
    state.breach[key] = value
  },
  [UpdateCompanyFilter](state, { key, value }) {
    state.company[key] = value
  },
}

export default mutations
